import type { ComponentType } from 'react';
import {
  Home20Regular,
  Home20Filled,
  Apps20Regular,
  Apps20Filled,
  Settings20Regular,
  Settings20Filled,
  Library20Regular,
  Library20Filled,
  BoxMultiple20Regular,
  BoxMultiple20Filled,
} from '@fluentui/react-icons';
import { isFeatureEnabled } from '@/featureFlags';

export interface ProjectNavItem {
  id: string;
  label: string;
  icon: ComponentType;
  activeIcon: ComponentType;
  /** Relative path from the project layout (e.g., './apps', './settings') */
  path: string;
  /** If true, NavLink uses exact (`end`) matching — required for `/` style absolute home links. */
  end?: boolean;
}

export interface ProjectNavSection {
  id: string;
  /** When omitted, the section renders unlabelled and without a divider. */
  label?: string;
  /** Optional icon rendered to the left of the section heading text. */
  icon?: ComponentType;
  items: ProjectNavItem[];
}

export const projectNavSections: ProjectNavSection[] = [
  {
    id: 'home',
    items: [
      { id: 'home', label: 'Home', icon: Home20Regular, activeIcon: Home20Filled, path: '/', end: true },
    ],
  },
  // Single project-scoped section. ProjectLayout overrides `label` with the
  // current environment name and supplies the folder icon at runtime — the static
  // "Environment" label here is only the fallback used before the environment loads.
  {
    id: 'project',
    label: 'Environment',
    items: [
      { id: 'apps', label: 'Apps', icon: Apps20Regular, activeIcon: Apps20Filled, path: './apps' },
      ...(isFeatureEnabled('knowledgeManagement') ? [{ id: 'knowledge', label: 'Knowledge', icon: Library20Regular as ComponentType, activeIcon: Library20Filled as ComponentType, path: './knowledge' }] : []),
      { id: 'sandboxes', label: 'Sandboxes', icon: BoxMultiple20Regular, activeIcon: BoxMultiple20Filled, path: './sandboxes' },
      { id: 'settings', label: 'Settings', icon: Settings20Regular, activeIcon: Settings20Filled, path: './settings' },
    ],
  },
];

/** Flat list derived from sections — backward compat */
export const projectNavItems: ProjectNavItem[] = projectNavSections.flatMap((s) => s.items);
